import { useEffect, useRef } from 'react';
import { onScroll } from '../utils/scroll.js';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion.js';

/*
 * The dashed rail running through the three stages. It fills from the top as
 * you scroll and a coral walker rides the leading edge; the dashes only march
 * while the walker is actually somewhere on the rail.
 *
 * On desktop it sits down the centre of the three-column grid; below `lg` the
 * stages stack, so it moves to the left gutter.
 */
export default function PathSpine() {
  const railRef = useRef(null);
  const fillRef = useRef(null);
  const walkerRef = useRef(null);
  const prefersReduced = usePrefersReducedMotion();

  useEffect(() => {
    const rail = railRef.current;
    const fill = fillRef.current;
    if (!rail || !fill) return undefined;

    if (prefersReduced) {
      fill.style.height = '100%';
      return undefined;
    }

    return onScroll((viewportHeight) => {
      const rect = rail.getBoundingClientRect();
      const progress = Math.max(
        0,
        Math.min(1, (viewportHeight * 0.62 - rect.top) / rect.height),
      );

      fill.style.height = `${progress * 100}%`;
      if (walkerRef.current) walkerRef.current.style.top = `${progress * 100}%`;
      rail.style.animationPlayState =
        progress > 0.001 && progress < 0.999 ? 'running' : 'paused';
    });
  }, [prefersReduced]);

  return (
    <div
      ref={railRef}
      aria-hidden="true"
      className="path-rail absolute bottom-[120px] left-[13px] top-0 w-1.5 rounded-full lg:left-1/2 lg:-ml-[3px]"
    >
      <div
        ref={fillRef}
        className="absolute left-0 top-0 h-0 w-1.5 rounded-full bg-forest"
      />
      {!prefersReduced && (
        <div
          ref={walkerRef}
          className="absolute left-1/2 top-0 -ml-[17px] -mt-[17px] flex size-[34px] items-center justify-center rounded-full border-4 border-cream bg-coral shadow-[0_4px_12px_rgb(239_106_90_/_0.5)]"
        >
          <div className="size-2.5 rounded-full bg-sun" />
        </div>
      )}
    </div>
  );
}
